var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0043 12.064H14.0043V11.064H6.0043V12.064Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0043 10.064H14.0043V9.06396H6.0043V10.064Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0043 8.06397H10.0043V7.06397H6.0043V8.06397Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2643 15.704C5.7843 17.2264 7.7879 18.064 9.9043 18.064C11.2619 18.064 12.5599 17.6944 13.9687 16.9044L16.8647 17.7444C16.9549 17.7706 17.0508 17.771 17.1412 17.7453C17.2316 17.7196 17.313 17.6689 17.3759 17.5991C17.4388 17.5292 17.4808 17.4431 17.497 17.3505C17.5132 17.2579 17.503 17.1626 17.4675 17.0756L16.4735 14.6356C17.4243 13.304 17.9043 11.7684 17.9043 10.064C17.9043 7.94877 17.0643 5.94637 15.5443 4.42396C14.0243 2.90156 12.0195 2.06396 9.9043 2.06396C7.7891 2.06396 5.7867 2.90396 4.2643 4.42396C2.7419 5.94397 1.9043 7.94877 1.9043 10.064C1.9043 12.1792 2.7443 14.1816 4.2643 15.704ZM4.9703 5.12997C6.3043 3.79756 8.0547 3.06396 9.9043 3.06396C11.7535 3.06396 13.5047 3.79597 14.8371 5.12997C16.1695 6.46397 16.9031 8.21477 16.9031 10.064C16.9031 11.6432 16.4331 13.0548 15.5067 14.2592C15.4535 14.3285 15.4193 14.4105 15.4076 14.4971C15.3959 14.5837 15.407 14.6718 15.4399 14.7528L16.1515 16.4976L14.0435 15.886C13.9784 15.867 13.9102 15.8615 13.843 15.8698C13.7757 15.878 13.7108 15.8999 13.6523 15.934C12.3287 16.706 11.1375 17.066 9.9043 17.066C8.0547 17.066 6.3007 16.3344 4.9703 15C3.6399 13.6656 2.9043 11.9132 2.9043 10.064C2.9043 8.21477 3.6363 6.46237 4.9703 5.12997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs);
export default __webpack_public_path__ + "static/media/icon-faqs.6bfc4a30e78b6096e315bf96dcc4964f.svg";
export { ForwardRef as ReactComponent };